var _desc, _defs, _g, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedBulb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "13036702-0a65-4452-82fa-e623a408e007"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "f17dd81f-1d22-49f1-bed8-a794dcf0bad3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(51.64 0 0 51.64 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 8.34)",
    id: "Rectangle_11"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -2.5605,
    y: -0.425,
    rx: 0,
    ry: 0,
    width: 5.121,
    height: 0.85
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 10.18)",
    id: "Path_29",
    clipPath: "url(#CLIPPATH_4)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_4"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0 -10.18)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-34.64, -83.6)",
    d: "M 32.181 83 L 33.12 84.287 C 33.2157742450569 84.4189449855511 33.3689595614294 84.49702487981864 33.532 84.497 L 35.754999999999995 84.497 C 35.91804043857059 84.49702487981864 36.07122575494309 84.4189449855511 36.166999999999994 84.287 L 37.105 83 C 37.169339398241924 82.91315346003837 37.20436359461656 82.80808087091447 37.205 82.7 L 32.085 82.7 C 32.08556692611706 82.80809234440682 32.12059813424956 82.91318596880431 32.185 83",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0.65)",
    id: "Path_30",
    clipPath: "url(#CLIPPATH_5)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_5"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0 -0.65)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-25.69, -26.97)",
    d: "M 25.686 20.221 C 23.574763882985955 20.18387426993531 21.636004252725304 21.382067583053463 20.725 23.287 C 19.749789102089625 25.601688889526965 20.22820269809065 28.273517154171508 21.946000000000005 30.106 C 22.286444561200945 30.622878816387512 22.488240817279248 31.21862544269376 22.532 31.836 C 22.679 32.723 22.845 33.729 23.94 33.729 L 27.432000000000002 33.729 C 28.532000000000004 33.729 28.694000000000003 32.722 28.840000000000003 31.834 C 28.88301999972905 31.21755288613863 29.08377711677917 30.622512923424036 29.423000000000002 30.105999999999998 C 31.14165130941874 28.274483577531175 31.621256005158628 25.602960035411428 30.647000000000002 23.287999999999997 C 29.735995747274696 21.383067583053457 27.79723611701404 20.184874269935303 25.685999999999996 20.221999999999998",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -9.26)",
    id: "Path_31",
    clipPath: "url(#CLIPPATH_6)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_6"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0 9.26)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-40.66, -1.82)",
    d: "M 40.66 3.552 C 40.81912989390372 3.5520000000000005 40.971742241643106 3.48878589578075 41.084264068711924 3.376264068711929 C 41.19678589578075 3.2637422416431083 41.26 3.1111298939037266 41.26 2.952 L 41.26 0.6 C 41.221159072836635 0.3010231242900346 40.96648928643022 0.07729812416871029 40.665 0.07729812416871029 C 40.36351071356978 0.07729812416871029 40.108840927163364 0.3010231242900348 40.07 0.6000000000000002 L 40.07 2.957 C 40.07 3.1161298939037265 40.13321410421925 3.2687422416431082 40.245735931288074 3.3812640687119293 C 40.35825775835689 3.49378589578075 40.51087010609628 3.5570000000000004 40.67 3.557",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.38 -8.21)",
    id: "Path_32",
    clipPath: "url(#CLIPPATH_7)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_7"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 4.38 8.21)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-21.18, -6.91)",
    d: "M 21.292 8.3 C 21.47483583300152 8.54042036319244 21.807886652259356 8.607447971540932 22.069492138925895 8.456472933164026 C 22.33109762559243 8.305497894787122 22.439691650653153 7.983592805963806 22.323 7.705000000000001 L 21.143 5.660000000000001 C 21.053145279582655 5.445478407837699 20.84740888023095 5.302209854808305 20.615038395559814 5.29234364282853 C 20.38266791088868 5.282477430848754 20.165527787190737 5.407791081285493 20.05781250623175 5.613924054225426 C 19.950097225272764 5.820057027165359 19.97121304082453 6.069871891893068 20.112000000000002 6.255000000000001 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.52 -4.96)",
    id: "Path_33",
    clipPath: "url(#CLIPPATH_8)"
  }, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_8"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 7.52 4.96)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6.99, -21.22)",
    d: "M 8.31 21.3 L 6.265 20.113 C 5.985251271660271 19.9887239488674 5.656801652873985 20.094967147813627 5.502832557869185 20.35953737606354 C 5.3488634628643865 20.624107604313455 5.418748151717668 20.962165143302105 5.665 21.144 L 7.71 22.325999999999997 C 7.9897487283397295 22.450276051132597 8.318198347126016 22.34403285218637 8.472167442130816 22.079462623936458 C 8.626136537135615 21.814892395686545 8.556251848282335 21.47683485669789 8.31 21.294999999999998",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.57 3.76)",
    id: "Path_34",
    clipPath: "url(#CLIPPATH_9)"
  }, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_9"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -7.57 -3.76)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-68.12, -56.52)",
    d: "M 69.387 56.563 L 67.342 55.382000000000005 C 67.06225127166027 55.257723948867415 66.73380165287399 55.363967147813646 66.5798325578692 55.628537376063555 C 66.4258634628644 55.893107604313464 66.49574815171768 56.23116514330211 66.742 56.413000000000004 L 68.787 57.594 C 68.97203476486085 57.73063154281801 69.21889352319701 57.74945688469854 69.42250702017826 57.64246348982295 C 69.62612051715952 57.535470094947364 69.75064721122494 57.32149172564495 69.74308543032485 57.09160292172105 C 69.73552364942476 56.861714117797156 69.59720447371066 56.65638159311109 69.387 56.563",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.72 -0.62)",
    id: "Path_35",
    clipPath: "url(#CLIPPATH_10)"
  }, _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_10"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 8.72 0.62)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1.74, -40.66)",
    d: "M 3.553 40.663 C 3.5502822079395173 40.335522926407265 3.2854770735927326 40.07071779206048 2.958 40.068 L 0.6 40.068 C 0.3690097702199611 40.037991409305384 0.14152517119151975 40.14438518955849 0.01648328812853117 40.340908799461666 C -0.10855859493445741 40.53743240936483 -0.10855859493445741 40.78856759063516 0.01648328812853128 40.98509120053833 C 0.14152517119151997 41.1816148104415 0.3690097702199612 41.28800859069461 0.6 41.257999999999996 L 2.958 41.257999999999996 C 3.2874165701846203 41.25525476679147 3.5530114386694667 40.98742800865549 3.553 40.657999999999994",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.76 -0.62)",
    id: "Path_36",
    clipPath: "url(#CLIPPATH_11)"
  }, _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_11"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -8.76 0.62)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-72.39, -40.66)",
    d: "M 73.491 40.068 L 71.128 40.068 C 70.82902312429003 40.10684092716336 70.60529812416871 40.36151071356978 70.60529812416871 40.663 C 70.60529812416871 40.964489286430215 70.82902312429003 41.21915907283663 71.128 41.257999999999996 L 73.491 41.257999999999996 C 73.72199022978003 41.28800859069461 73.94947482880848 41.1816148104415 74.07451671187147 40.98509120053833 C 74.19955859493446 40.78856759063516 74.19955859493446 40.53743240936483 74.07451671187147 40.340908799461666 C 73.94947482880848 40.14438518955849 73.72199022978003 40.037991409305384 73.491 40.068",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.52 3.72)",
    id: "Path_37",
    clipPath: "url(#CLIPPATH_12)"
  }, _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_12"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 7.52 -3.72)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6.99, -56.49)",
    d: "M 7.714 55.382 L 5.67 56.563 C 5.4237481517176676 56.74483485669789 5.353863462864386 57.08289239568655 5.507832557869185 57.34746262393646 C 5.661801652873985 57.612032852186374 5.990251271660271 57.7182760511326 6.27 57.594 L 8.31 56.413 C 8.556251848282333 56.23116514330211 8.626136537135615 55.89310760431345 8.472167442130814 55.62853737606354 C 8.318198347126016 55.363967147813625 7.9897487283397295 55.2577239488674 7.710000000000001 55.382",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.55 -4.98)",
    id: "Path_38",
    clipPath: "url(#CLIPPATH_13)"
  }, _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_13"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -7.55 4.98)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-68.11, -21.2)",
    d: "M 67.048 22.406 C 67.15333026297083 22.40645023823246 67.25687968309956 22.378837059531467 67.348 22.326 L 69.393 21.144000000000002 C 69.60320447371066 21.050618406888912 69.74152364942476 20.845285882202848 69.74908543032485 20.615397078278953 C 69.75664721122494 20.38550827435506 69.63212051715952 20.171529905052644 69.42850702017826 20.064536510177057 C 69.22489352319701 19.957543115301466 68.97803476486085 19.97636845718199 68.793 20.113000000000003 L 66.75 21.3 C 66.52349103720596 21.43921875951408 66.4156140502117 21.71090234823127 66.4849243857085 21.967581624021108 C 66.5542347212053 22.224260899810943 66.7842017623329 22.404717478234208 67.05 22.411",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.36 -8.17)",
    id: "Path_39",
    clipPath: "url(#CLIPPATH_14)"
  }, _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_14"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -4.36 8.17)",
    id: "Rectangle_12",
    x: -10.4575,
    y: -11.0765,
    rx: 0,
    ry: 0,
    width: 20.915,
    height: 22.153
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,90,72)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-56.51, -6.96)",
    d: "M 57.378 5.448 C 57.09293312817047 5.286508072418629 56.73102722483292 5.383550491763753 56.565 5.666 L 55.385 7.71 C 55.268308349346846 7.988592805963805 55.37690237440757 8.31049789478712 55.6385078610741 8.461472933164027 C 55.90011334774064 8.61244797154093 56.23316416699848 8.54542036319244 56.416 8.305 L 57.6 6.261 C 57.76149192758137 5.975933128170471 57.664449508236245 5.614027224832921 57.382 5.448",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBulb);
export default __webpack_public_path__ + "static/media/redBulb.da4d8b44c6cfce858eb34d7d96f0d3a0.svg";
export { ForwardRef as ReactComponent };